import { isAfter, parseISO, startOfDay, subYears } from 'date-fns'

export function idadeMenorQue(dataAtendimento: Instant, dataNascimento: LocalDate, limiteIdadeEmAnos: number) {
  return isAfter(parseISO(dataNascimento), subYears(startOfDay(dataAtendimento), limiteIdadeEmAnos))
}
